/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Submit_Failed12Inputs */

const en_us2_body_assessment_error_submit_failed12 = /** @type {(inputs: Body_Assessment_Error_Submit_Failed12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photos couldn't be sent. Check your connection and try again.`)
};

const pt_br2_body_assessment_error_submit_failed12 = /** @type {(inputs: Body_Assessment_Error_Submit_Failed12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para enviar as fotos. Confira a conexão e tente de novo.`)
};

const es_419_body_assessment_error_submit_failed12 = /** @type {(inputs: Body_Assessment_Error_Submit_Failed12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron enviar las fotos. Revisa tu conexión e inténtalo de nuevo.`)
};

const pt_pt2_body_assessment_error_submit_failed12 = /** @type {(inputs: Body_Assessment_Error_Submit_Failed12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar as fotos. Verifica a ligação e tenta de novo.`)
};

const fr_fr2_body_assessment_error_submit_failed12 = /** @type {(inputs: Body_Assessment_Error_Submit_Failed12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'envoyer les photos. Vérifie ta connexion et réessaie.`)
};

const de_de2_body_assessment_error_submit_failed12 = /** @type {(inputs: Body_Assessment_Error_Submit_Failed12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Fotos konnten nicht gesendet werden. Prüf deine Verbindung und versuch es erneut.`)
};

const it_it2_body_assessment_error_submit_failed12 = /** @type {(inputs: Body_Assessment_Error_Submit_Failed12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile inviare le foto. Controlla la connessione e riprova.`)
};

/**
* | output |
* | --- |
* | "The photos couldn't be sent. Check your connection and try again." |
*
* @param {Body_Assessment_Error_Submit_Failed12Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_submit_failed12 = /** @type {((inputs?: Body_Assessment_Error_Submit_Failed12Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Submit_Failed12Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_submit_failed12(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_submit_failed12(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_submit_failed12(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_submit_failed12(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_submit_failed12(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_submit_failed12(inputs)
	return en_us2_body_assessment_error_submit_failed12(inputs)
});
export { body_assessment_error_submit_failed12 as "body-assessment.error.SUBMIT_FAILED" }